(function ($) {
  Drupal.behaviors.pcgProductMobileV1 = {
    attach: function (context, settings) {
      $('.pcg-product-mobile-v1').each(function () {
        var thisFormatter = $(this);
        // Check if the reviews img is tranparent.gif and add hidden class to .reviews parent class
        var reviews = thisFormatter.find('.reviews'),
          reviewsImg = reviews.find('img');

        if (reviewsImg.attr('src') == '/media/export/images/global/transparent.gif') {
          reviews.addClass('hidden');
        }

        // For CTA button loading...
        thisFormatter.find('.button.cta').addClass('mobile');
      });

      // Add CTA button loading...
      $('.button.cta.mobile', context).not('.action-spp').on('click', function(e) {
        e.preventDefault();

        var loadingId = site.loading.show({
          'target': e.target,
          'matchTarget': ['display', 'height', 'width'],
          'css': {
            'text-align': 'center',
            'vertical-align': 'top'
          }
        });

        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
    }
  };
})(jQuery);
